module.exports = __webpack_public_path__ + "static/media/shopping-bag.636d1004.png";